module["exports"] = [
  "1 hoog",
  "2 hoog",
  "3 hoog"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/address/secondary_address.js
 ** module id = 802
 ** module chunks = 0
 **/